import styled from 'styled-components'

export default styled.div`
  width: 50%;
  padding: 15px;
  margin: 1em auto;
  font-size: 1.5em;
  text-align: center;
`
